import { ModuleWithProviders, NgModule } from '@angular/core';
import { ErrorService } from './api-error.service';
import { ComponentCreatorService } from './component-creator.service';
import { CountriesService } from './countries.service';
import { FormStoreService } from './form-store.service';
import { PhoneNumberService } from './phone-number.service';
import { SuggestionsHintsService } from './suggestions-hints.service';
import { ValidationService } from './validation.service';
import { ZipCodeService } from './zip-code.service';

@NgModule({
  imports: [],
  declarations: [],
  providers: [],
})
export class CoreModule {
  public static forRoot(): ModuleWithProviders<CoreModule> {
    return {
      ngModule: CoreModule,
      providers: [
        ErrorService,
        ValidationService,
        ComponentCreatorService,
        CountriesService,
        PhoneNumberService,
        ZipCodeService,
        FormStoreService,
        SuggestionsHintsService,
      ],
    };
  }
}
